module.exports = __webpack_public_path__ + "img/46.dae28df3.png";